/*
 * Authors: mariushirjanu, Koen, Triadi
 * Created: 30/10/2015
 * Upgraded: 20/03/2023
 */
import _ from 'underscore';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { GaFormlyService, IExtraFieldConfigurationObject } from '@app/shared/formly/ga-formly.service';
import { IInvoiceAddress, IOrderEntryAddress, IShippingAddress, OrderEntryLocationDataService } from '../order-entry-location-data.service';
import { OrderEntryLocationFormService } from '../order-entry-location-form.service';
import { BaseLocationAddressComponent, LOCATION_ADDRESS_TEMPLATE } from './base-location-address.component';
import { CountryDataService } from '@app/shared/location/country-data.service';
import { OrderEntryWebshopService } from '@app/main/order/entry/webshop/order-entry-webshop.service';
import { ILocationExtended } from '@type_definitions/datatypes';
import { OrderEntryLocationService } from '../order-entry-location.service';
import { GaValidateService } from '@app/shared/formly/ga-validate.service';
import { GaDeferredService } from '@app/shared/services/ga-deferred.service';

@Component({
  selector: 'order-location-address-recent',
  template: LOCATION_ADDRESS_TEMPLATE
})
export class OrderLocationAddressRecentComponent extends BaseLocationAddressComponent implements OnInit {
  private locationField:IExtraFieldConfigurationObject;

  constructor(
    protected countryDataService:CountryDataService,
    protected formlyService:GaFormlyService,
    protected orderEntryLocationService:OrderEntryLocationService,
    protected orderEntryLocationDataService:OrderEntryLocationDataService,
    protected orderEntryLocationFormService:OrderEntryLocationFormService,
    protected orderEntryWebshopService:OrderEntryWebshopService,
    validateService:GaValidateService,
    deferredService:GaDeferredService,
    changeDetectorRef:ChangeDetectorRef
  ) {
    super(
      countryDataService,
      formlyService,
      orderEntryLocationService,
      orderEntryLocationDataService,
      orderEntryLocationFormService,
      orderEntryWebshopService,
      validateService,
      changeDetectorRef,
      deferredService
    );
  }

  protected createFields():IExtraFieldConfigurationObject[] {
    this.locationField = this.orderEntryLocationFormService.createLocationField(this.onLocationChange, 'location','ORDERENTRY.LOCATION.SEARCH_RECENT_ADDRESS');
    return [ this.locationField ].concat(super.createFields());
  }

  protected fillFields():void {
    super.fillFields();

    const selectedShopId:number = this.orderEntryWebshopService.selectedShop?.id;
    const selectedCountryId:number = this.orderEntryWebshopService.selectedCountry?.id;
    const testMode:boolean = this.orderEntryWebshopService.testMode;

    // perform load only when webshop and country is selected
    if (selectedShopId && selectedCountryId) {
      //load recent locations
      this.formlyService.fillField(
        this.locationField, 
        this.orderEntryLocationDataService.recentLocations(this.dataType, selectedShopId, selectedCountryId, testMode)
          .then((recentLocations:IOrderEntryAddress[]) => {
            const locations:ILocationExtended[] = _.map(recentLocations, (address:IInvoiceAddress|IShippingAddress) => {
              //copy office to location objects
              address.location.office = (<IShippingAddress>address).office;
              return address.location;
            });
  
            let selectedLocation:ILocationExtended;
            const loadedAddress:IInvoiceAddress | IShippingAddress = this.locationToModel.getLoadedAddress(this.addressType);
            if (loadedAddress?.location?.id) {
              selectedLocation = _.find(locations, (loc:ILocationExtended) => loc.id === loadedAddress.location.id);
            }
            // if there is a default location, select that
            if(!selectedLocation){
              const selectAddress:IOrderEntryAddress = _.find(recentLocations, (address:IOrderEntryAddress) => address.default);
              selectedLocation = selectAddress?.location;
            }
            if(!selectedLocation){
              selectedLocation = locations[0];
            }
  
            if (selectedLocation) {
              this.addressForm.patchValue(this.getInitialModel(selectedLocation));
            }
  
            return locations;
          })
          .finally(() => {
            this.onValidationReadyDeferred.resolve();
          })
      );
    }
  }
}